import { render, staticRenderFns } from "./TrainingCoursesAddNew.vue?vue&type=template&id=15b1c4ab&"
import script from "./TrainingCoursesAddNew.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports